import React from "react";

export default function SettingsSection({ title, icon, children, id }) {
  return (
    <section
      id={id}
      className="rounded-2xl shadow-2xl bg-surface-elevated border border-border-light"
      aria-labelledby={`${id}-title`}
    >
      <header className="flex items-center gap-3 px-6 py-4 border-b border-border bg-surface rounded-t-2xl">
        {icon}
        <h2
          id={`${id}-title`}
          className="text-base font-semibold text-text-primary"
        >
          {title}
        </h2>
      </header>
      <div className="p-6 space-y-6">{children}</div>
    </section>
  );
}
